import React, {useState} from 'react';
import FormikDropdown from 'src/components/formik-dropdown';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import EditableTable from 'src/views/admin/EditableTable';
import {NAME_TITLES} from 'shared/registration/constants';
import req from 'shared/req';
import AccessibleTypeahead from 'shared/components/accessible-typeahead';
import {useFormikContext} from 'formik';

interface DistrictAdmin {
  id: string;
  email: string;
  title: string;
  firstName: string;
  lastName: string;
  districtId: string;
  districtName: string;
}

interface District {
  _id: string;
  name: string;
}

const TitleSelector = (): React.ReactElement => (
  <FormikDropdown name="title" placeholder="Title" options={NAME_TITLES} />
);

const apiFieldMap = {
  first_name: 'firstName',
  last_name: 'lastName',
};

function DistrictSelector(): React.ReactElement {
  const form = useFormikContext<DistrictAdmin>();
  const [name, setName] = useState(form.values.districtName || '');
  const selectedDistrict: District = {
    _id: form.values.districtId,
    name,
  };

  const searchDistricts = async (districtName): Promise<District[]> =>
    req<{_id: string; name: string}[], District[]>({
      url: `/v1/admin/districts?name=${districtName}`,
    });

  const setDistrict = (district): void => {
    form.setValues({
      ...form.values,
      districtId: district._id,
      districtName: district.name,
    });
    setName(district.name);
  };

  return (
    <AccessibleTypeahead
      id="district-name-typeahead"
      labelKey="name"
      onInputChange={setName}
      onSearch={searchDistricts}
      onSelect={setDistrict}
      placeholder="District Name"
      required
      value={selectedDistrict}
    />
  );
}

function DistrictAdmin(): React.ReactElement | null {
  const columns: ColumnSettings<DistrictAdmin>[] = [
    {
      name: 'email',
      title: 'Email',
    },
    {
      name: 'title',
      title: 'Title',
      FormField: TitleSelector,
    },
    {
      name: 'firstName',
      title: 'First Name',
    },
    {
      name: 'lastName',
      title: 'Last Name',
    },
    {
      name: 'districtId',
      title: 'District Name',
      FormField: DistrictSelector,
      renderValue: (_, district): string => district.districtName,
    },
    {
      name: 'password',
      title: 'Password',
      hidden: true,
    },
  ];

  return (
    <>
      <div className="shared-font title">District Admins</div>
      <EditableTable
        basePath="/v1/admin/district-admins"
        defaultSortKey="firstName"
        columns={columns}
        identifier="districtAdmins"
        apiFieldMap={apiFieldMap}
        defaultValues={{
          title: NAME_TITLES[0].value,
        }}
      />
    </>
  );
}

export default DistrictAdmin;
